import type { TShowStatus } from '@schemas'

const ALLOWED_STATUSES: ReadonlyArray<TShowStatus> = ['accepting_entries']

export function statusAllowsLabelPrinting(status: TShowStatus | null | undefined): boolean {
  if (!status) return false
  return ALLOWED_STATUSES.includes(status)
}

export function showAllowsLabelPrinting(
  show:
    | {
        status?: TShowStatus | null
        labelPrintingDisabled?: boolean | null
      }
    | null
    | undefined
): boolean {
  if (!show) return false
  if (show.labelPrintingDisabled) return false
  return statusAllowsLabelPrinting(show.status ?? null)
}
